import React from "react";
import MediaSkeleton, { IMediaSkeletonProps } from "./MediaSkeleton";

export interface ImageSkeletonProps extends IMediaSkeletonProps {
    src: string;
    alt?: string;
}

export default function ImageSkeleton(props: ImageSkeletonProps) {
    const { src, alt = "", children, ...rest } = props;

    return (
        <MediaSkeleton {...rest}>
            <img src={src} alt={alt} style={{ width: "100%" }} />
        </MediaSkeleton>
    );
}
